<template>
  <div>
    <iframe :src="url" width="100%" height="1000" seamless> </iframe>
  </div>
</template>

<script>
export default {
  name: 'test',
  data() {
    return {
      token: process.env.VUE_APP_PUBLIC_DATA_TOKEN,
    };
  },
  computed: {
    url() {
      if (process.env.VUE_APP_URL === 'http://localhost:8080')
        return '/api/public/dashboard?&access_token=' + this.token;
      else return process.env.VUE_APP_URL + '/api/public/dashboard?&access_token=' + this.token;
    },
  },
};
</script>

<style scoped></style>
